// extracted by mini-css-extract-plugin
module.exports = {"member-shop":"style_member-shop__FBgLx"};